export const NAME_FIELD_CONFIG: Record<
  string,
  {
    label: string;
    min: number;
    max: number;
    allowSpaces: boolean;
  }
> = {
  name: {
    label: 'Name',
    min: 1,
    max: 50,
    allowSpaces: true,
  },
  first_name: {
    label: 'First Name',
    min: 1,
    max: 50,
    allowSpaces: false,
  },
  sponsor_name: {
    label: 'Sponsor Name',
    min: 1,
    max: 50,
    allowSpaces: true,
  },
  last_name: {
    label: 'Last Name',
    min: 2,
    max: 50,
    allowSpaces: false,
  },
  main_contact: {
    label: 'Main Contact',
    min: 2,
    max: 50,
    allowSpaces: true,
  },
  title: {
    label: 'Title',
    min: 3,
    max: 50,
    allowSpaces: true,
  },
};
